module.exports = __webpack_public_path__ + "assets/img/contractcomparsion-app1.53c2cc51.png";